const DashboardCard = ({ title, value, change, changeText, percentage, percentageText, onClick }) => {
  return (
    <div 
      className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 hover:shadow-md transition-shadow cursor-pointer"
      onClick={onClick}
    >
      <h3 className="text-gray-500 text-sm font-medium">{title}</h3>
      <div className="mt-2 flex justify-between items-end flex-grow">
        <div>
          <p className="text-2xl font-bold">{value}</p>
          <div className={`flex items-center mt-1 ${change.startsWith('+') ? 'text-green-500' : 'text-red-500'}`}>
            <span className="text-sm">{change}</span>
            <span className="text-xs ml-1">{changeText}</span>
          </div>
        </div>
        {percentage && (
          <div className="flex flex-col items-end">
            <div className="w-16 h-2 bg-gray-200 rounded-full overflow-hidden">
              <div 
                className="h-full bg-blue-500" 
                style={{ width: `${percentage}%` }}
              ></div>
            </div>
            <span className="text-xs text-gray-500 mt-1">{percentageText}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default DashboardCard;
